// HOCs
import { inputWithFloatingLabel } from "../../HOC/inputWithFloatingLabel";
import { inputWithSuffix } from "../../HOC/inputWithSuffix";
import { inputWithLabel } from "../../HOC/inputWithLabel";
import { inputWithStyle } from "../../HOC/inputWithStyle";
import { inputWithHelpers } from "../../HOC/inputWithHelpers";
import { inputWithPrefix } from "../../HOC/inputWithPrefix";
import { inputWithError } from "../../HOC/inputWithError";

// Components
import InputBase from "../Inputs/InputBase";
import InputCurrencyBase from "../Inputs/InputCurrencyBase";
import TextAreaBase from "../Inputs/TextAreaBase";

export const InputWithHelpersFloatingLabel = inputWithError(inputWithStyle(
  inputWithHelpers(inputWithFloatingLabel(InputBase))
));
export const InputWithSuffixHelpersFloatingLabel = inputWithError(
  inputWithStyle(
    inputWithSuffix(inputWithHelpers(inputWithFloatingLabel(InputBase)))
  )
);
export const InputWithLabelHelpers = inputWithStyle(
  inputWithHelpers(inputWithLabel(InputBase))
);
export const InputCurrencyWithSuffixFloatingLabelHelpers = inputWithError(
  inputWithStyle(
    inputWithSuffix(inputWithHelpers(inputWithFloatingLabel(InputCurrencyBase)))
  )
);
export const InputWithLabelErrorPrefix = inputWithLabel(
  inputWithError(inputWithStyle(inputWithPrefix(InputBase)))
);
export const InputWithFileUpload = inputWithStyle(
  inputWithLabel(inputWithSuffix(InputBase))
);
export const InputWithSuffixFloatingLabel = inputWithStyle(
  inputWithSuffix(inputWithFloatingLabel(InputBase))
);
export const TextAreaWithSuffixHelpersFloatingLabel = inputWithStyle(
  inputWithSuffix(inputWithHelpers(inputWithFloatingLabel(TextAreaBase)))
);